
const PathList = {
    Login: "/",
    Dashboard:"/dashboard",
    UserManagement:"/user",
    UserDetails:"/user/user-profile",
    ContentManagement:"/content-management",
    NotificationManagement:"/notifications",
    ReportManagement:"/report-user",
    ReportUserDetails:"/report-user/report-user-details",
    feedbacks:"/feedbacks",
    HashtagManagement:"/hashtag-management",
    FeedbacksModule:"/feedbacks-module",
    FAQs:"/faqs",
    CommentReasons:"/comment-reasons",
    ReportedComments:"/reported-comments",
    Strike:"/streak-management",
}

export default PathList
